import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../hooks'
import {
  DocumentFolderFormModal,
  getDocumentFolderFormErrorNotification,
  getDocumentFolderFormSuccessNotification,
} from '../../../../Document'
import { UserProfileTabId, useUserProfileContext } from '../../../../User'

export function useUserProfilePageCreateFolderAction() {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const { handleCloseModal, handleReloadTabs, setModal, userData } =
    useUserProfileContext()

  function handleFolderError() {
    handleAddErrorNotification(getDocumentFolderFormErrorNotification(t))
  }

  function handleFolderSuccess(data) {
    handleCloseModal()
    handleAddSuccessNotification(
      getDocumentFolderFormSuccessNotification(data, { t })
    )
    handleReloadTabs([UserProfileTabId.Documents])
  }

  function handleClickCreateFolder() {
    setModal(
      <DocumentFolderFormModal
        parent={userData?.directory_id?.toString()}
        onClose={handleCloseModal}
        onError={handleFolderError}
        onSuccess={handleFolderSuccess}
      />
    )
  }

  return {
    handleClickCreateFolder,
  }
}
